import { useQuery } from "@tanstack/react-query";
import client from "shared/utils/axios-config";
import { ClassType } from "shared/types";
import { UpcomingClassRow } from "hooks/queries/user";

export interface ClassDeleteCheck {
  upcoming_classes: UpcomingClassRow[];
  totals: { classes: number; bookings: number };
  can_remove_all: boolean;
  // Reward programmes whose class scope names this class ("loyalty" /
  // "referral"): deleting it leaves their credits unclaimable until the
  // reward is re-pointed (System Review R6).
  reward_programs?: string[];
}

// Asked by the Hapus Kelas pop-up: the class's upcoming sessions, which
// block the delete. Fresh every time it opens.
export const classDeleteCheckOptions = (classId: string, enabled: boolean) => ({
  queryKey: ["classtype_id", classId, "delete-check"],
  queryFn: async (): Promise<ClassDeleteCheck> =>
    (await client.get(`/v1/class/${classId}/delete-check`)).data.data,
  enabled: enabled && !!classId,
  staleTime: 0,
  gcTime: 0,
});

/* eslint-disable react-hooks/rules-of-hooks */
const getAllClassTypeByBusinessId = (type?: string) => {
  return useQuery({
    queryKey: ["classtype", type],
    queryFn: async (): Promise<ClassType[] | undefined> => {
      const res = await client.get(`/v1/class`, { params: { type } });
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
    staleTime: 5 * 60_000,
  });
};

const getClassTypeByClassId = (classId?: string) => {
  return useQuery({
    queryKey: ["classtype_id", classId],
    queryFn: async (): Promise<ClassType | undefined> => {
      const res = await client.get(`/v1/class/${classId}`);
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
  });
};

export { getAllClassTypeByBusinessId, getClassTypeByClassId };
